import { Link } from "react-router-dom";
import InputCom from "../Helpers/InputCom";
import PageTitle from "../Helpers/PageTitle";
import Layout from "../Partials/Layout";
import DiscountCoupon from "../Helpers/DiscountCoupon";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "../../api/axios";
import { useNavigate } from "react-router-dom";
import {
  transformCartDataForDiscount,
  calculateSubtotal,
  calculateFinalTotal,
  updatePaymentOptionsWithDiscount,
  formatDiscountForOrder,
} from "../Helpers/discountHelpers";

export default function CheakoutPage() {
  const navigate = useNavigate();

  // PayHere configuration - change this for production
  const PAYHERE_CONFIG = {
    sandbox: false, // Set to false for production
    sandboxUrl: "https://sandbox.payhere.lk/pay/checkout",
    productionUrl: "https://www.payhere.lk/pay/checkout",
  };

  useEffect(() => {
    // Set up PayHere callbacks
    window.payhere.onCompleted = function onCompleted(orderId) {
      console.log("Payment completed. OrderID:" + orderId);
      toast.success("Payment completed successfully!");
      navigate(`/checkout-success?orderId=ph-${orderId}`);
    };

    window.payhere.onDismissed = function onDismissed() {
      console.log("Payment dismissed");
      toast.info("Payment was cancelled. Please try again.");
    };

    window.payhere.onError = function onError(error) {
      console.log("Error:" + error);
      toast.error("Payment failed. Please try again.");
    };
  }, [navigate]);

  const [productList, setProductList] = useState([]);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    country: "",
    address: "",
    district: "",
    secondaryPhone: "",
    differentAddress: false,
    paymentMethod: "",
    deliveryPhone: "",
    deliveryAddress: "",
    deliveryDistrict: "",
    deliverySecondaryPhone: "",
  });

  const [shippingFee, setShippingFee] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [appliedDiscount, setAppliedDiscount] = useState(null);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const cartItems = localStorage.getItem("cart_list");
    if (cartItems !== null) {
      console.log("cardItems");
      console.log(cartItems);
      setProductList(JSON.parse(cartItems));
    }
  }, []);

  const handleFormChange = (e, fieldName) => {
    const { value, type, checked } = e.target;

    if (fieldName === "district" && value === "Colombo") {
      setShippingFee(295);
    } else if (fieldName === "district") {
      setShippingFee(395);
    }

    if (formData.differentAddress) {
      if (fieldName === "deliveryDistrict" && value === "Colombo") {
        setShippingFee(295);
      } else if (fieldName === "deliveryDistrict") {
        setShippingFee(395);
      }
    }

    if (fieldName === "differentAddress") {
      if (e.target.checked) {
        if (formData.deliveryDistrict === "Colombo") {
          setShippingFee(295);
        } else {
          setShippingFee(395);
        }
      } else {
        if (formData.district === "Colombo") {
          setShippingFee(295);
        } else {
          setShippingFee(395);
        }
      }
    }

    setFormData({
      ...formData,
      [fieldName]: type === "checkbox" ? checked : value,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName?.trim())
      newErrors.firstName = "First name is required";
    if (!formData.lastName?.trim())
      newErrors.lastName = "Last name is required";
    if (!formData.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }
    if (!formData.phone?.trim()) newErrors.phone = "Phone number is required";
    if (!formData.address?.trim()) newErrors.address = "Address is required";
    if (!formData.district?.trim()) newErrors.district = "District is required";
    if (!formData.paymentMethod)
      newErrors.paymentMethod = "Select a payment method";
    if (formData.differentAddress) {
      if (!formData.deliveryPhone?.trim())
        newErrors.deliveryPhone = "Phone number is required";
      if (!formData.deliveryAddress?.trim())
        newErrors.deliveryAddress = "Address is required";
      if (!formData.deliveryDistrict?.trim())
        newErrors.deliveryDistrict = "District is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlePaymentMethod = (e) => {
    setFormData({
      ...formData,
      paymentMethod: e.target.id,
    });
  };

  // Discount handlers
  const handleDiscountApplied = (discount) => {
    setAppliedDiscount(discount);
  };

  const handleDiscountRemoved = () => {
    setAppliedDiscount(null);
  };

  const processCartData = (cartData) => {
    const [identifiers, quantities] = cartData;

    return identifiers.map((identifier, index) => {
      const [p_id, c_id, s_id] = identifier.split("_");
      return {
        product_id: p_id,
        color_id: c_id,
        size_id: s_id,
        quantity: quantities[index],
      };
    });
  };

  const getMetaPurchasePayload = (finalTotal) => {
    const parsedValue = Number.parseFloat(finalTotal);
    if (!Number.isFinite(parsedValue)) {
      return null;
    }

    const normalizedValue = Number(parsedValue.toFixed(2));
    if (normalizedValue <= 0) {
      return null;
    }

    return {
      value: normalizedValue,
      currency: "LKR",
    };
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fill all the required fields");
      return;
    }

    // Prevent multiple submissions
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    const processedCartData = processCartData(productList);
    const controller = new AbortController();

    const order = async () => {
      try {
        let response;
        const orderData = {
          ...formData,
          shippingFee: shippingFee,
          items: processedCartData,
          discount: formatDiscountForOrder(appliedDiscount),
        };

        // Call different endpoints based on payment method
        switch (formData.paymentMethod) {
          case "KOKO":
            response = await axios.post("/orders/koko", orderData);
            if (response.data.requestData) {
              localStorage.removeItem("cart_list");
              const form = document.createElement("form");
              form.method = "POST";
              form.action =
                "https://prodapi.paykoko.com/api/merchants/orderCreate";
              form.style.display = "none";

              Object.keys(response.data.requestData).forEach((key) => {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = response.data.requestData[key];
                form.appendChild(input);
              });

              document.body.appendChild(form);
              form.submit();
              return;
            }
            break;

          case "PAYHERE":
            response = await axios.post("/orders/payhere", orderData);
            if (response.data.paymentData) {
              console.log("paymentData");
              console.log(response.data.paymentData);
              localStorage.removeItem("cart_list");

              const payment = {
                sandbox: false, // Set to false for production
                merchant_id: response.data.paymentData.merchant_id,
                return_url: response.data.paymentData.return_url,
                cancel_url: response.data.paymentData.cancel_url,
                notify_url: response.data.paymentData.notify_url,
                first_name: formData.firstName,
                last_name: formData.lastName,
                email: formData.email,
                phone: formData.phone,
                address: formData.address,
                city: formData.district,
                country: "Sri Lanka",
                order_id: response.data.paymentData.order_id,
                items: response.data.paymentData.items,
                currency: response.data.paymentData.currency,
                amount: response.data.paymentData.amount,
                hash: response.data.paymentData.hash,
              };

              window.payhere.startPayment(payment);
              return;
            }
            break;

          case "COD":
            response = await axios.post("/orders", orderData);
            break;

          case "BANK":
            response = await axios.post("/orders", orderData);
            break;

          default:
            throw new Error("Invalid payment method");
        }

        if (response.status === 201) {
          const metaPurchasePayload = getMetaPurchasePayload(totals.total);
          if (window.fbq && metaPurchasePayload) {
            window.fbq("track", "Purchase", metaPurchasePayload);
          }

          toast.success("Order placed successfully");
          localStorage.removeItem("cart_list");
          navigate(`/checkout-success?orderId=${response.data.order.id}`);
        }
      } catch (error) {
        if (error.name === "AbortError") {
          console.error("Request timed out");
          toast.error("Order request timed out. Please try again.");
          navigate(`/checkout-fail?error=Request timed out. Please try again.`);
        } else {
          console.error(error);
          toast.error(
            "An error occurred while placing the order. Please try again."
          );
          navigate(
            `/checkout-fail?error=An error occurred while placing the order. Please try again.`
          );
        }
      } finally {
        setIsSubmitting(false);
      }
    };

    order();
  };

  // Calculate totals with discount
  const subtotal = calculateSubtotal(productList);
  const totals = calculateFinalTotal(subtotal, shippingFee, appliedDiscount);
  const baseTotal = totals.total;

  // Payment options for card UI - base options without fees
  const basePaymentOptions = [
    {
      id: "COD",
      label: "Cash On Delivery",
      logo: process.env.PUBLIC_URL + "/assets/images/dollars.png",
      price: baseTotal,
    },
    {
      id: "BANK",
      label: "Bank Transfer",
      logo: process.env.PUBLIC_URL + "/assets/images/transfer.png",
      price: baseTotal,
    },
    {
      id: "PAYHERE",
      label: "Visa/Master/Amex",
      logo: process.env.PUBLIC_URL + "/assets/images/atm-card.png",
      price: baseTotal,
    },
    {
      id: "KOKO",
      label: "KOKO",
      logo: process.env.PUBLIC_URL + "/assets/images/koko.png.webp",
      price: baseTotal,
      installment: "",
      // highlight: true,
    },
  ];

  // Update payment options with discount-adjusted pricing
  const paymentOptions = updatePaymentOptionsWithDiscount(
    basePaymentOptions,
    baseTotal
  );

  return (
    <Layout childrenClasses="pt-0 pb-0">
      <div className="checkout-page-wrapper w-full bg-white pb-[60px]">
        <div className="w-full mb-5">
          <PageTitle
            title="Checkout"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "checkout", path: "/checkout" },
            ]}
          />
        </div>
        <div className="checkout-main-content w-full">
          <div className="container-x mx-auto">
            <div className="w-full lg:flex lg:space-x-[30px]">
              <div className="lg:w-1/2 w-full">
                <h1 className="sm:text-2xl text-xl text-qblack font-medium mb-5">
                  Billing Details
                </h1>
                <div className="form-area">
                  <form onSubmit={handleFormSubmit}>
                    <div className="sm:flex sm:space-x-5 items-center mb-6">
                      <div className="sm:w-1/2  mb-5 sm:mb-0">
                        <InputCom
                          label="First Name*"
                          placeholder="First Name"
                          inputClasses="w-full h-[50px]"
                          name="firstName"
                          value={formData.firstName}
                          inputHandler={(e) => handleFormChange(e, "firstName")}
                        />
                        {errors.firstName && (
                          <span className="text-red-500">
                            {errors.firstName}
                          </span>
                        )}
                      </div>
                      <div className="flex-1">
                        <InputCom
                          label="Last Name*"
                          placeholder="Last Name"
                          inputClasses="w-full h-[50px]"
                          name="lastName"
                          value={formData.lastName}
                          inputHandler={(e) => handleFormChange(e, "lastName")}
                        />
                        {errors.lastName && (
                          <span className="text-red-500">
                            {errors.lastName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex space-x-5 items-center mb-6">
                      <div className="w-1/2">
                        <InputCom
                          label="Email Address*"
                          placeholder="E-mail"
                          inputClasses="w-full h-[50px]"
                          name="email"
                          value={formData.email}
                          inputHandler={(e) => handleFormChange(e, "email")}
                        />
                        {errors.email && (
                          <span className="text-red-500">{errors.email}</span>
                        )}
                      </div>
                    </div>
                    <div className="flex space-x-5 items-center mb-6">
                      <div className="flex-1">
                        <InputCom
                          label="Phone Number*"
                          placeholder="077 *** ****"
                          inputClasses="w-full h-[50px]"
                          name="phone"
                          value={formData.phone}
                          inputHandler={(e) => handleFormChange(e, "phone")}
                        />
                        {errors.phone && (
                          <span className="text-red-500">{errors.phone}</span>
                        )}
                      </div>
                      <div className="flex-1">
                        <InputCom
                          label="Secondary Phone Number*"
                          placeholder="077 *** ****"
                          inputClasses="w-full h-[50px]"
                          name="secondaryPhone"
                          value={formData.secondaryPhone}
                          inputHandler={(e) =>
                            handleFormChange(e, "secondaryPhone")
                          }
                        />
                      </div>
                    </div>

                    <div className=" mb-6">
                      <div className="w-full">
                        <InputCom
                          label="Address*"
                          placeholder="Address"
                          inputClasses="w-full h-[50px]"
                          name="address"
                          value={formData.address}
                          inputHandler={(e) => handleFormChange(e, "address")}
                        />
                        {errors.address && (
                          <span className="text-red-500">{errors.address}</span>
                        )}
                      </div>
                    </div>
                    <div className="flex space-x-5 items-center mb-6">
                      <div className="w-1/2">
                        <h1 className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">
                          District
                        </h1>
                        <div className="relative w-full">
                          <select
                            className="block w-full rounded border border-gray-300 bg-white px-3 py-2 text-[13px] text-qgraytwo focus:border-pink-500 focus:ring focus:ring-pink-100 transition appearance-none pr-8"
                            name="district"
                            value={formData.district}
                            onChange={(e) => handleFormChange(e, "district")}
                          >
                            <option value="">Select District</option>
                            <option value="Ampara">Ampara</option>
                            <option value="Anuradhapura">Anuradhapura</option>
                            <option value="Badulla">Badulla</option>
                            <option value="Batticaloa">Batticaloa</option>
                            <option value="Colombo">Colombo</option>
                            <option value="Galle">Galle</option>
                            <option value="Gampaha">Gampaha</option>
                            <option value="Hambantota">Hambantota</option>
                            <option value="Jaffna">Jaffna</option>
                            <option value="Kalutara">Kalutara</option>
                            <option value="Kandy">Kandy</option>
                            <option value="Kegalle">Kegalle</option>
                            <option value="Kilinochchi">Kilinochchi</option>
                            <option value="Kurunegala">Kurunegala</option>
                            <option value="Mannar">Mannar</option>
                            <option value="Matale">Matale</option>
                            <option value="Matara">Matara</option>
                            <option value="Monaragala">Monaragala</option>
                            <option value="Mullaitivu">Mullaitivu</option>
                            <option value="Nuwara Eliya">Nuwara Eliya</option>
                            <option value="Polonnaruwa">Polonnaruwa</option>
                            <option value="Puttalam">Puttalam</option>
                            <option value="Ratnapura">Ratnapura</option>
                            <option value="Trincomalee">Trincomalee</option>
                            <option value="Vavuniya">Vavuniya</option>
                          </select>
                          {/* Chevron icon */}
                          <svg
                            className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                          {errors.district && (
                            <span className="text-red-500">
                              {errors.district}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* <div className="flex space-x-2 items-center mb-10">
                      <div>
                        <input type="checkbox" name="" id="create" />
                      </div>
                      <label
                        htmlFor="create"
                        className="text-qblack text-[15px] select-none"
                      >
                        Create an account?
                      </label>
                    </div> */}
                    <div>
                      <h1 className="text-2xl text-qblack font-medium mb-3">
                        Delivery Address
                      </h1>
                      <div className="flex space-x-2 items-center mb-10">
                        <div>
                          <input
                            type="checkbox"
                            name="differentAddress"
                            id="address"
                            onChange={(e) =>
                              handleFormChange(e, "differentAddress")
                            }
                          />
                        </div>
                        <label
                          htmlFor="address"
                          className="text-qblack text-[15px] select-none"
                        >
                          Ship to a different address
                        </label>
                      </div>
                    </div>
                    {formData.differentAddress && (
                      <div>
                        <div className="flex space-x-5 items-center mb-6">
                          <div className="flex-1">
                            <InputCom
                              label="Phone Number*"
                              placeholder="077 *** ****"
                              inputClasses="w-full h-[50px]"
                              name="deliveryPhone"
                              value={formData.deliveryPhone}
                              inputHandler={(e) =>
                                handleFormChange(e, "deliveryPhone")
                              }
                            />
                            {errors.deliveryPhone && (
                              <span className="text-red-500">
                                {errors.deliveryPhone}
                              </span>
                            )}
                          </div>
                          <div className="flex-1">
                            <InputCom
                              label="Secondary Phone Number*"
                              placeholder="077 *** ****"
                              inputClasses="w-full h-[50px]"
                              name="deliverySecondaryPhone"
                              value={formData.deliverySecondaryPhone}
                              inputHandler={(e) =>
                                handleFormChange(e, "deliverySecondaryPhone")
                              }
                            />
                          </div>
                        </div>
                        <div className=" mb-6">
                          <div className="w-full">
                            <InputCom
                              label="Address*"
                              placeholder="Address"
                              inputClasses="w-full h-[50px]"
                              name="deliveryAddress"
                              value={formData.deliveryAddress}
                              inputHandler={(e) =>
                                handleFormChange(e, "deliveryAddress")
                              }
                            />
                            {errors.deliveryAddress && (
                              <span className="text-red-500">
                                {errors.deliveryAddress}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="flex space-x-5 items-center mb-6">
                          <div className="w-1/2">
                            <h1 className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">
                              District
                            </h1>
                            <div className="relative w-full">
                              <select
                                className="block w-full rounded border border-gray-300 bg-white px-3 py-2 text-[13px] text-qgraytwo focus:border-pink-500 focus:ring focus:ring-pink-100 transition appearance-none pr-8"
                                name="deliveryDistrict"
                                value={formData.deliveryDistrict}
                                onChange={(e) =>
                                  handleFormChange(e, "deliveryDistrict")
                                }
                              >
                                <option value="">Select District</option>
                                <option value="Ampara">Ampara</option>
                                <option value="Anuradhapura">
                                  Anuradhapura
                                </option>
                                <option value="Badulla">Badulla</option>
                                <option value="Batticaloa">Batticaloa</option>
                                <option value="Colombo">Colombo</option>
                                <option value="Galle">Galle</option>
                                <option value="Gampaha">Gampaha</option>
                                <option value="Hambantota">Hambantota</option>
                                <option value="Jaffna">Jaffna</option>
                                <option value="Kalutara">Kalutara</option>
                                <option value="Kandy">Kandy</option>
                                <option value="Kegalle">Kegalle</option>
                                <option value="Kilinochchi">Kilinochchi</option>
                                <option value="Kurunegala">Kurunegala</option>
                                <option value="Mannar">Mannar</option>
                                <option value="Matale">Matale</option>
                                <option value="Matara">Matara</option>
                                <option value="Monaragala">Monaragala</option>
                                <option value="Mullaitivu">Mullaitivu</option>
                                <option value="Nuwara Eliya">
                                  Nuwara Eliya
                                </option>
                                <option value="Polonnaruwa">Polonnaruwa</option>
                                <option value="Puttalam">Puttalam</option>
                                <option value="Ratnapura">Ratnapura</option>
                                <option value="Trincomalee">Trincomalee</option>
                                <option value="Vavuniya">Vavuniya</option>
                              </select>
                              {/* Chevron icon */}
                              <svg
                                className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M19 9l-7 7-7-7"
                                />
                              </svg>
                              {errors.deliveryDistrict && (
                                <span className="text-red-500">
                                  {errors.deliveryDistrict}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
              <div className="flex-1">
                <h1 className="sm:text-2xl text-xl text-qblack font-medium mb-5">
                  Order Summary
                </h1>

                <div className="w-full px-10 py-[30px] border border-[#EDEDED]">
                  <div className="sub-total mb-6">
                    <div className=" flex justify-between mb-5">
                      <p className="text-[13px] font-medium text-qblack uppercase">
                        Product
                      </p>
                      <p className="text-[13px] font-medium text-qblack uppercase">
                        total
                      </p>
                    </div>
                    <div className="w-full h-[1px] bg-[#EDEDED]"></div>
                  </div>
                  <div className="product-list w-full mb-[30px]">
                    <ul className="flex flex-col space-y-5">
                      {productList.length > 2 &&
                        productList[2].map((product, index) => (
                          <li key={index}>
                            <div className="flex justify-between items-center">
                              <div>
                                <h4 className="text-[15px] text-qblack mb-2.5">
                                  {product[0].p_name}
                                  <sup className="text-[13px] text-qgray ml-2 mt-2">
                                    x{productList[1][index]}
                                  </sup>
                                </h4>
                                <p className="text-[13px] text-qgray">
                                  {product[1]}{" "}
                                  {product[2] ? `, ${product[2]}` : ""}
                                  {product[4] ? `, ${product[4]}` : ""}
                                </p>
                              </div>
                              <div>
                                <span className="text-[15px] text-qblack font-medium">
                                  {productList[3][index]} LKR
                                </span>
                              </div>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                  <div className="w-full h-[1px] bg-[#EDEDED]"></div>

                  <div className="mt-[30px]">
                    <div className=" flex justify-between mb-5">
                      <p className="text-[13px] font-medium text-qblack uppercase">
                        SUBTOTAL
                      </p>
                      <p className="text-[15px] font-medium text-qblack uppercase">
                        {subtotal.toFixed(2)} LKR
                      </p>
                    </div>
                  </div>

                  <div className="w-full mt-[30px]">
                    <div className="sub-total mb-6">
                      <div className=" flex justify-between mb-5">
                        <div>
                          <span className="text-xs text-qgraytwo mb-3 block">
                            SHIPPING
                          </span>
                          {/* <p className="text-base font-medium text-qblack">
                            Free Shipping
                          </p> */}
                        </div>
                        <p className="text-[15px] font-medium text-qblack">
                          {shippingFee} LKR
                        </p>
                      </div>
                      <div className="w-full h-[1px] bg-[#EDEDED]"></div>
                    </div>
                  </div>

                  {/* Discount Section */}
                  <div className="w-full mt-[30px]">
                    <DiscountCoupon
                      cartItems={transformCartDataForDiscount(productList)}
                      cartSubtotal={subtotal}
                      onDiscountApplied={handleDiscountApplied}
                      onDiscountRemoved={handleDiscountRemoved}
                      appliedDiscount={appliedDiscount}
                      disabled={isSubmitting}
                      className="mb-6"
                    />
                  </div>

                  {/* Discount Display */}
                  {appliedDiscount && (
                    <div className="mt-[30px]">
                      <div className=" flex justify-between mb-5">
                        <p className="text-[13px] font-medium text-qblack uppercase">
                          DISCOUNT ({appliedDiscount.code})
                        </p>
                        <p className="text-[15px] font-medium text-green-600">
                          -LKR {appliedDiscount.amount.toFixed(2)}
                        </p>
                      </div>
                    </div>
                  )}

                  <div className="mt-[30px]">
                    <div className=" flex justify-between mb-5">
                      <p className="text-2xl font-medium text-qblack">Total</p>
                      <p className="text-2xl font-medium text-qred">
                        LKR {baseTotal.toFixed(2)}
                      </p>
                    </div>
                  </div>
                  <div className="shipping mt-[30px]">
                    {/* Payment method card grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 my-6">
                      {paymentOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`border rounded-lg p-2 flex flex-col items-center justify-center min-h-[120px] cursor-pointer transition-all duration-150 ${
                            formData.paymentMethod === option.id
                              ? "border-pink-500 shadow-lg bg-pink-50"
                              : "border-gray-200 bg-white"
                          } ${option.highlight ? "ring-2 ring-yellow-200" : ""}`}
                          onClick={() =>
                            setFormData({
                              ...formData,
                              paymentMethod: option.id,
                            })
                          }
                        >
                          {option.logo ? (
                            <img
                              src={option.logo}
                              alt={option.label}
                              className="h-8 mb-2"
                            />
                          ) : (
                            <div className="h-8 mb-2 flex items-center justify-center text-lg font-bold text-gray-700">
                              {option.label}
                            </div>
                          )}
                          <div className="font-bold text-[10px] text-qblack">
                            LKR {option.price.toLocaleString()}
                          </div>
                          <div className="text-[9px] text-gray-500">
                            {option.label}
                          </div>
                          {option.installment && (
                            <div className="mt-2 text-[10px] text-gray-700 bg-gray-100 px-2 py-1 rounded">
                              {option.installment}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    {errors.paymentMethod && (
                      <span className="text-red-500">
                        {errors.paymentMethod}
                      </span>
                    )}
                  </div>
                  <button
                    onClick={handleFormSubmit}
                    disabled={isSubmitting}
                    className={`w-full black-btn flex justify-center items-center py-3 px-6 rounded text-sm font-semibold ${
                      isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    {isSubmitting ? "Processing Order..." : "Place Order Now"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
